/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Numbersall1Inputs */

const en_numbersall1 = /** @type {(inputs: Numbersall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All numbers`)
};

const de_numbersall1 = /** @type {(inputs: Numbersall1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Zahlen`)
};

/**
* | output |
* | --- |
* | "All numbers" |
*
* @param {Numbersall1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const numbersall1 = /** @type {((inputs?: Numbersall1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Numbersall1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_numbersall1(inputs)
	return de_numbersall1(inputs)
});
export { numbersall1 as "numbersAll" }